import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { createStyles, makeStyles, Theme } from '@material-ui/core';

import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router';

import UserChip from '../user-chip';
import { ROUTE_PATHS } from '../../contants/ROUTE_PATHS';
import { IHeaderData } from './interfaces';
import { baseTheme } from '../../theme';
import AdminHeaderNavigation from '../navigation-components/admin-header-navigation';

const getHeaderData = (): IHeaderData => ({
  logo: {
    path: '/images/Reliht_logo_reversed.svg',
    altText: 'Reliht - Equiping Leaders for the Kingdom of God',
  },
  tagLine: 'Equipping Leaders for the Kingdom of God',
});

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingLeft: theme.spacing(1),
      lineHeight: .5,
    },
    logo: {
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(4),
      border: 'none',
      width: '100px',
    },
    title: {
      flexGrow: 1,
      fontSize: '1em',
    },
  }),
);

function HeaderBarComponent(props: any): JSX.Element {
  const classes = useStyles(baseTheme);
  const headerData = getHeaderData();
  const auth = useSelector((state: any) => state.auth);

  return (
    <AppBar position="static" className={classes.root}>
      <Toolbar disableGutters={true} variant={'dense'}>
        <Link to={ROUTE_PATHS.HOME} className={classes.logo} >
          <img src={headerData.logo.path} alt={headerData.logo.altText} />
        </Link>
          {window.innerWidth > 600 &&
          <Grid container item xs={1} md={3} >
            <Typography variant="h6" className={classes.title}>
              {headerData.tagLine}
            </Typography>
          </Grid>}
        {!auth.loading && auth.authenticated && (auth.currUser && auth.currUser.emailVerified) ?
            <AdminHeaderNavigation {...props} /> : <Grid container item xs={1} md={4}/>}
        <UserChip />
      </Toolbar>
    </AppBar>
  );
}
const HeaderBar = withRouter(HeaderBarComponent);

export default HeaderBar;
